import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 新品状态
    newStatusList: [{
      id: 0,
      name: "不是新品"
    }, {
      id: 1,
      name: "新品"
    }],
    // 推荐状态
    recommandStatusList: [{
      id: 0,
      name: "不推荐"
    }, {
      id: 1,
      name: "推荐"
    }],
    //促销类型
    promotionTypeList: [
      {
        id: 0,
        name: "没有促销使用原价"
      },
      {
        id: 1,
        name: "使用促销价"
      },
      {
        id: 2,
        name: "使用会员价"
      },
      {
        id: 3,
        name: "使用阶梯价格"
      },
      {
        id: 4,
        name: "使用满减价格"
      },
      {
        id: 5,
        name: "限时购"
      },

    ],
    navList: [
      {
        name: '用户管理',
        pathId: 'accoutlist',
        hasChild: true,
        id: '2',
        childrenList: [
          {
            name: '用户列表',
            pathId: 'accoutlist',
            id: 'accoutlist'
          }
        ]
      },

      {
        name: '广告管理',
        pathId: 'companylist',
        hasChild: true,
        id: '4',
        childrenList: [
          {
            name: '广告列表',
            pathId: 'companylist',
            id: 'companylist'
          },
          {
            name: '闪屏页/启动图',
            pathId: 'splash',
            id: 'splash'
          },
          {
            name: '首页店铺推荐',
            pathId: 'store',
            id: 'store'
          }
        ]
      },

      {
        name: '店铺管理',
        pathId: 'goodslist',
        hasChild: true,
        id: '6',
        childrenList: [
          {
            name: '商品分类',
            pathId: 'goodstype',
            id: 'goodstype'
          },
          {
            name: '店铺列表',
            pathId: 'goodslist',
            id: 'goodslist'
          },
        ]
      },
      {
        name: '商品管理',
        pathId: 'replenishmentList',
        hasChild: true,
        id: '10',
        childrenList: [
          {
            name: '商品列表',
            pathId: 'replenishmentList',
            id: 'replenishmentList'
          },
          // {
          //   name: '规格分类',
          //   pathId: 'noreplenishmentlist',
          //   id: 'noreplenishmentlist'
          // },
          // {
          //   name: '参数分类',
          //   pathId: 'totallist',
          //   id: 'totallist'
          // },
        ]
      },
      {
        name: '订单管理',
        pathId: 'rateList',
        hasChild: true,
        id: '13',
        childrenList: [
          {
            name: '订单列表',
            pathId: 'rateList',
            id: 'rateList'
          },
          {
            name: '待开票列表',
            pathId: 'profit',
            id: 'profit'
          },
          {
            name: '已开票列表',
            pathId: 'profitsuccess',
            id: 'profitsuccess'
          },
          {
            name: '退款列表',
            pathId: 'tuikuan',
            id: 'tuikuan'
          },
        ]
      },
      {
        name: '地址管理',
        pathId: 'addressList',
        hasChild: true,
        id: '14',
        childrenList: [
          {
            name: '退货地址列表',
            pathId: 'addressList',
            id: 'addressList'
          },
        ]
      }
    ],
    navListOther: [
      // {
      //   name: '用户管理',
      //   pathId: 'accoutlist',
      //   hasChild: true,
      //   id: '2',
      //   childrenList: [
      //     {
      //       name: '用户列表',
      //       pathId: 'accoutlist',
      //       id: 'accoutlist'
      //     }
      //   ]
      // },

      {
        name: '广告管理',
        pathId: 'companylist',
        hasChild: true,
        id: '4',
        childrenList: [
          {
            name: '广告列表',
            pathId: 'companylist',
            id: 'companylist'
          },
          {
            name: '闪屏页/启动图',
            pathId: 'splash',
            id: 'splash'
          },
          {
            name: '首页店铺推荐',
            pathId: 'store',
            id: 'store'
          }
        ]
      },

      {
        name: '店铺管理',
        pathId: 'goodslist',
        hasChild: true,
        id: '6',
        childrenList: [
          {
            name: '商品分类',
            pathId: 'goodstype',
            id: 'goodstype'
          },
          {
            name: '店铺列表',
            pathId: 'goodslist',
            id: 'goodslist'
          },
        ]
      },
      {
        name: '商品管理',
        pathId: 'replenishmentList',
        hasChild: true,
        id: '10',
        childrenList: [
          {
            name: '商品列表',
            pathId: 'replenishmentList',
            id: 'replenishmentList'
          },
          // {
          //   name: '规格分类',
          //   pathId: 'noreplenishmentlist',
          //   id: 'noreplenishmentlist'
          // },
          // {
          //   name: '参数分类',
          //   pathId: 'totallist',
          //   id: 'totallist'
          // },
        ]
      },
      // {
      //   name: '订单管理',
      //   pathId: 'rateList',
      //   hasChild: true,
      //   id: '13',
      //   childrenList: [
      //     {
      //       name: '订单列表',
      //       pathId: 'rateList',
      //       id: 'rateList'
      //     },
      //     {
      //       name: '待开票列表',
      //       pathId: 'profit',
      //       id: 'profit'
      //     },
      //     {
      //       name: '已开票列表',
      //       pathId: 'profitsuccess',
      //       id: 'profitsuccess'
      //     },
      //     {
      //       name: '退款列表',
      //       pathId: 'tuikuan',
      //       id: 'tuikuan'
      //     },
      //   ]
      // },
      // {
      //   name: '地址管理',
      //   pathId: 'addressList',
      //   hasChild: true,
      //   id: '14',
      //   childrenList: [
      //     {
      //       name: '退货地址列表',
      //       pathId: 'addressList',
      //       id: 'addressList'
      //     },
      //   ]
      // }
    ],

  },
  getters: {
    getNavList: (state) => {
      return state.navList
    },
    getNavListOther: (state) => {
      return state.navListOther
    },

    getPromotionTypeList: (state) => {
      return state.promotionTypeList
    },
    getNewStatusList: (state) => {
      return state.newStatusList
    },
    getRecommandStatusList: (state) => {
      return state.recommandStatusList
    },
  },
  mutations: {
  },
  actions: {

  }
})
